import { Component, Input } from '@angular/core';
import { splitData } from '../../../shared/utils/format.util';

const STAT_CONFIG = {
  manager: {
    p1Label: 'Awarded',   p1Field: 'totalPointsAwarded',
    p2Label: 'Unclaimed', p2Field: 'totalPointsUnclaimed',
    t1Label: 'Awarded',   t1Field: 'totalCreditsAwarded',
    t2Label: 'Count',     t2Field: 'totalCreditsCount',
  },
  seller: {
    p1Label: 'Earned',    p1Field: 'totalPointsEarned',
    p2Label: 'Redeemed',  p2Field: 'totalPointsRedeemed',
    t1Label: 'Earned',    t1Field: 'totalCreditsEarned',
    t2Label: 'Redeemed',  t2Field: 'totalCreditsRedeemed',
  },
};

@Component({
  selector: 'app-dashboard-rewards-summary',
  templateUrl: './dashboard-rewards-summary.component.html',
  styleUrls: ['./dashboard-rewards-summary.component.scss']
})
export class DashboardRewardsSummaryComponent {

  @Input() role: 'manager' | 'seller' = 'seller';
  @Input() dashboardData: any = null;
  @Input() isLoading = false;

  showCash = false;

  get rewardSummary(): any {
    if (!this.dashboardData) { return null; }
    return this.role === 'manager'
      ? this.dashboardData.TotalSalesAndActivityChallenges
      : this.dashboardData.TotalChallenges;
  }

  get config() {
    return STAT_CONFIG[this.role];
  }

  get cashEarned(): number {
    if (!this.dashboardData) { return 0; }
    return this.dashboardData.cashEarned || 0;
  }

  readonly splitData = splitData;
}
